'use strict';

module.exports = {
  keyPrefix: 'reduxPersist:',
  REHYDRATE: 'persist/REHYDRATE'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/lib/constants.js
 ** module id = 300
 ** module chunks = 0
 **/